export const findMeasurementImage = productImages => {
  if (!productImages) return

  const measurementImage = productImages.find(image => image.layout)
  const hasInitialMeasurementImage = !!measurementImage

  return {measurementImage, hasInitialMeasurementImage}
}
